
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Password } from 'primereact/password';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { View_count_logins, View_date_created, View_whatsapp_number } from '../constants/dataView';
import { deletecustomer, getallusers } from '../Helper/links';
import pattern from "../Helper/pattern";
import API from "../Helper/server/API";
import UserNew from './userNewComponet'
import UserEdit from './userEditComponet'

import { View_state } from '../functions/data_view';
import UserEditPermissions from './userEditPermissionsComponet';
import { Skeleton } from 'primereact/skeleton';

function Users() {
    const toast = useRef(null);
    const Navigate = useNavigate();
    const [show_edit_user, set_show_edit] = useState(false);

    const items = Array.from({ length: 10 }, (v, i) => i);

    const [show_new_user, set_show_new_user] = useState(false);
    const [show_permissions_user, set_show_permissions_user] = useState(false);
    const [user_show, set_user_show] = useState(null)
    // const [show_new_user,set_show_new_user] =useState(false);
    //ــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــ
    const [state, set_state] = useState(true);
    const [show_delete, set_show_delete] = useState(false);
    const [name_phone, setname_phone] = useState("");
    const [loading_customers, set_loading_customers] = useState(false);
    const [users, set_users] = useState([]);

    const [users_view, set_users_view] = useState([]);
    const clearFilter = () => {
        setname_phone("");
        GetUsers();
    };
    const handel_name_phone = (e) => {
        setname_phone(e.target.value)
    }
    const renderHeader = () => {
        return (
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-9">
                        <div className="flex justify-content-between" style={{ fontFamily: "Cairo", fontSize: "15px" }} dir="rtl">
                            <InputText
                                value={name_phone}
                                onChange={(e) => handel_name_phone(e)}
                                placeholder="الأسم أو رقم الهاتف"
                                className="col-md-4"
                                style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%" }}
                            />
                            <Button
                                dir="ltr"
                                type="button"
                                icon="fa fa-remove"
                                outlined
                                severity="danger"
                                onClick={clearFilter}
                                style={{ marginRight: "0px" }}
                            />
                            <Button
                                dir="ltr"
                                type="button"
                                icon="fa fa-search"
                                outlined
                                onClick={search}
                                style={{ marginRight: "5px" }}
                            />
                        </div>
                    </div>
                    <div className="col-md-1" style={{ textAlign: "left" }}>
                        <Button icon="fa fa-refresh" rounded onClick={GetUsers} outlined />
                    </div>
                    <div className="col-md-2" style={{ textAlign: "left" }}>
                        <Button icon="fa fa-plus pl-2" label='مستخدم جديد' outlined onClick={(e) => set_show_new_user(true)} />
                    </div>

                </div>
            </div>
        );
    };
    const search = (e) => {
        e.preventDefault();
        //___________________________________________________________________
        //                  Search
        var resulte = []
        // eslint-disable-next-line array-callback-return
        users.map((customer) => {
            if (
                !name_phone || name_phone.toString().trim() === "" ||
                (
                    (customer.name != null && (customer.name.toString().startsWith(name_phone.toString())
                        || customer.name.toString().endsWith(name_phone.toString())))
                    //_____________________________________________
                    || (customer.phone != null && (customer.phone.toString().startsWith(name_phone.toString())
                        || customer.phone.toString().endsWith(name_phone.toString())))
                    //_____________________________________________
                    || (customer.username != null && (customer.username.toString().startsWith(name_phone.toString())
                        || customer.username.toString().endsWith(name_phone.toString())))
                )
            ) {
                resulte.push(customer);
            }
        })
        set_users_view(resulte);

    };
    //                      Get Customers
    const GetUsers = async () => {
        set_loading_customers(true);
        const response = await API.get(`${getallusers}?del=0`);
        if (response?.success) {
            set_users(response.users);
            set_users_view(response.users);
        }
        set_loading_customers(false);
    }

    const View_Button = (item) => {
        return (
            <>
                <Button
                    type="button"
                    icon="fa fa-edit"
                    text
                    onClick={(e) => {
                        set_user_show(item)
                        set_show_edit(true)
                    }}
                />

            </>
        )
    }
    const View_permissions = (item) => {
        return (
            <>
                <Button
                    type="button"
                    label='صـــلاحيات'
                    outlined
                    onClick={(e) => {
                        set_user_show(item)
                        set_show_permissions_user(true)
                    }}
                />
            </>
        )
    }

    useEffect(() => {
        GetUsers()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const scrollStyle = {
        overflowY: "auto",
        scrollbarWidth: "thin", // للمتصفحات غير Chrome
    };
    const scrollBarCSS = `
    ::-webkit-scrollbar {
            display: block !important;
            width: 5px;
            height: 8px;
    }
    `;
    return (
        <div className="page-wrapper" dir="rtl" >
            <div className="content-wrapper">
                <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />
                <Dialog dir="rtl" header={<center className='color-ebony '> مستخـــدم جــــديد  <i className='fa fa-user '></i> <i className='fa fa-plus '></i></center>} visible={show_new_user} maximizable={true} style={{ width: window.innerWidth <= 1230 ? '100%' : '70vw', height: window.innerWidth <= 1230 ? '100%' : 'auto', fontFamily: "Cairo" }} onHide={() => set_show_new_user(false)} maximized={window.innerWidth <= 1230 ? true : false}>
                    <UserNew toast={toast} set_show_new_user={set_show_new_user} users={users} set_users={set_users} set_users_view={set_users_view}  ></UserNew>
                </Dialog>
                <Dialog dir="rtl" header={<center className='color-ebony '>تعــديل المستخـــدم   <i className='fa fa-edit '></i></center>}
                    visible={show_edit_user} maximizable style={{ width: '70vw', fontFamily: "Cairo" }} maximized={window.innerWidth <= 1230 ? true : false}
                    onHide={() => set_show_edit(false)}
                >
                    <UserEdit toast={toast} set_show_edit={set_show_edit} user={user_show} GetUsers={GetUsers} ></UserEdit>
                </Dialog>
                <Dialog dir="rtl" header={<center className='color-ebony '>صـــلاحيات المستخـــدم   <i className='fa fa-edit '></i></center>}
                    visible={show_permissions_user} maximizable style={{ width: '70vw', fontFamily: "Cairo" }} maximized={window.innerWidth <= 1230 ? true : false}
                    onHide={() => set_show_permissions_user(false)}
                >
                    <UserEditPermissions toast={toast} set_show_permissions_user={set_show_permissions_user} user={user_show} GetUsers={GetUsers} ></UserEditPermissions>
                </Dialog>
                <div className="page-heading">
                    <h1 className="page-title"> المستخدمين </h1>
                </div>
                <div className="card p-2">
                    <style>{scrollBarCSS}</style>
                    {
                        loading_customers ?
                            <DataTable value={items}
                                header={renderHeader}
                                className="p-datatable-striped"
                                tableStyle={{ minWidth: '50rem' }} style={{ fontFamily: "Cairo", direction: "rtl" }}>
                                <Column field="ID_user" header="رقم المستخدم" sortable style={{ textAlign: "right" }} body={<Skeleton />}></Column>

                                <Column field="name" header="الاسم" sortable style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="username" header="البريد الإلكتروني" style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="phone" header="رقم الهاتف" style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="whatsapp_number" header="رقم الواتساب" style={{ textAlign: "right" }} body={<Skeleton />}></Column>

                                <Column field="count_login" header="محاولات الدخول" style={{ textAlign: "right", width: "10%" }} body={<Skeleton />} ></Column>
                                <Column field="ip_address_login" header="عنوان الجهاز" style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="state" header="حالتة" sortable style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="permissions" header="الصلاحيات" style={{ textAlign: "right", width: "10%" }} body={<Skeleton />}></Column>
                                <Column field="date_created" header="تـاريخ الإضـافة" style={{ textAlign: "right", width: "10%" }} body={<Skeleton />}></Column>
                                <Column field="ID_customer" header="أجراء" style={{ textAlign: "right", width: "10%" }} body={<Skeleton />} ></Column>
                            </DataTable>
                            :
                            <DataTable value={users_view} stripedRows
                                header={renderHeader} selectionMode="multiple"
                                // paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50,100]}
                                paginatorClassName={<i className="pi pi-angle-right"  ></i>}
                                emptyMessage={<center><h4>لا يوجد عملاء</h4></center>}
                                scrollable scrollHeight="750px"
                                tableStyle={scrollStyle}
                                style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "15px", border: "10px" }}
                            >
                                <Column field="ID_user" header="رقم المستخدم" sortable style={{ textAlign: "right" }}></Column>

                                <Column field="name" header="الاسم" sortable style={{ textAlign: "right" }}></Column>
                                <Column field="username" header="البريد الإلكتروني" style={{ textAlign: "right" }}></Column>
                                <Column field="phone" header="رقم الهاتف" style={{ textAlign: "right" }}></Column>
                                <Column field="whatsapp_number" header="رقم الواتساب" body={View_whatsapp_number} style={{ textAlign: "right" }}></Column>

                                <Column field="count_login" body={View_count_logins} header="محاولات الدخول" style={{ textAlign: "right", width: "10%" }} ></Column>
                                <Column field="ip_address_login" header="عنوان الجهاز" style={{ textAlign: "right" }}></Column>
                                <Column field="state" body={View_state} header="حالتة" sortable style={{ textAlign: "right" }}></Column>
                                <Column field="permissions" body={View_permissions} header="الصلاحيات" style={{ textAlign: "right", width: "10%" }} ></Column>
                                <Column field="date_created" body={View_date_created} header="تـاريخ الإضـافة" style={{ textAlign: "right", width: "10%" }} ></Column>
                                <Column field="ID_customer" body={View_Button} header="أجراء" style={{ textAlign: "right", width: "10%" }} ></Column>
                            </DataTable>
                    }

                </div>


            </div>
        </div>
    )
}

export default Users


